import { Text, Tooltip, Stack } from '@mantine/core'

export interface Actor {
  email?: string
  name?: string
  roles?: string[]
  legacy?: boolean
}

export function ActorCell({ actor }: { actor: Actor }) {
  if (actor.legacy || !actor.email) {
    return (
      <Tooltip label="Evento anterior à auditoria v2 — ator não capturado" withArrow>
        <Text size="sm" c="dimmed" fs="italic">&lt;legacy&gt;</Text>
      </Tooltip>
    )
  }
  const tooltip = `${actor.email}\nPapéis: ${(actor.roles ?? []).join(', ') || '(sem papéis)'}`
  return (
    <Tooltip label={tooltip} multiline withArrow position="right">
      <Stack gap={0}>
        <Text size="sm" fw={500}>{actor.name || actor.email}</Text>
        <Text size="xs" c="dimmed">{actor.email}</Text>
      </Stack>
    </Tooltip>
  )
}
